module.exports = __webpack_public_path__ + "img/WhatsApp-3.4c1a5cb7.jpeg";